import {deleteCookie, setCookie} from '../utils/cookie'

export default {
  store (state, payload) {
    Object.assign(state, payload)
  },
  // 更新页面跳转路由记录
  updateDepthHistory (state, payload) {
    const position = state.depthHistory.indexOf(payload)
    if (position > -1) {
      state.depthHistory.splice(position, 1)
    } else {
      state.depthHistory.push(payload)
    }
  },
  // 更新绑定船票信息
  updateBindTicket (state, payload) {
    state.bindTicket = payload
    deleteCookie('shorexId')
  },
  // 退出登录
  logout (state) {
    state.token = ''
    state.bindTicket = ''
    state.goodsCartNum = 0
    state.smCartNum = 0
    state.userCoupon = null
    state.isFirstLogin = false
    deleteCookie('isFirstLogin')
    deleteCookie('shorexId')
    deleteCookie('pcp_token')
  },
  // 解绑船票
  bindout (state) {
    state.bindTicket = ''
    state.goodsCartNum = 0
    state.smCartNum = 0
  },
  storeBookingPageData (state, payload) {
    state.bookingPage = payload
  },
  SET_IS_MASK_VALUE: (state, isMaskValue) => {
    state.isMaskValue = isMaskValue
  },
  setBookingContactInfo(state,payload) {
    state.bookingContactInfo=payload
  },
  SET_USER_COUPON(state,payload) {
    state.userCoupon=payload
  },
  SET_IS_FIRST_LOGIN(state,payload) {
    state.isFirstLogin=payload
    setCookie('isFirstLogin', payload);
  },
  SET_COMMON_INFO(state,payload) {
    state.commonInfo=payload
  },
  SET_IS_FROM_PCP_MINI_PROGRAM(state,payload) {
    state.isFromPcpMiniProgram=payload
  },
  SET_HOME_PCP_BIND_COUPON_INFO(state,payload) {
    state.homePcpBindCouponInfo=payload
  }
}
